import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService, AppInformationService, ArkUnitOfWork, UtilityService } from 'app/core/core.module';
import { Nomination, NominationAssignment } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { confirm, alert } from 'devextreme/ui/dialog';
import moment from 'moment';
import _ from 'lodash';
import { xor } from 'lodash';
import { NominationSettingDialogComponent } from '../nomination-setting-dialog/nomination-setting-dialog.component';

@Component({
    selector: 'app-nomination-tally',
    templateUrl: './nomination-tally.component.html',
    styleUrls: ['./nomination-tally.component.scss'],
    standalone: false,
})
export class NominationTallyComponent implements OnInit {
    requiredDeacons = 4;
    requiredShepherding = 4;
    requiredExecutive = 3;
    deacons: any;
    sheps: any;
    execs: any;
    nominationTallies: any;
    nominationTallyGroups: any;
    filter: any = {};

    nomination: Nomination;
    nominations: any;
    people: any[];
    roles = ['Deacon', 'Shepherding Elder', 'Executive Elder'];
    nominationGroups: any;
    assignment: any = {};
    assignments: NominationAssignment[];
    showJoinedDate = false;

    @ViewChild('nominationGrid') nominationGrid: DxDataGridComponent;

    selectedMonthId: number;
    givingTypes: any[];
    types: any[];
    otherAccounts: any[];

    specialAccountId: number;
    batchId: number;
    saveEnable = true;
    addProcessing = false;
    processing = false;

    isAdmin = false;
    lastAdded: any;

    constructor(
        private uow: ArkUnitOfWork,
        private appInfo: AppInformationService,
        public auth: AuthService,
        private utility: UtilityService,
        private modalService: BsModalService
    ) {}

    async ngOnInit() {
        const result = (await this.utility.getNominationInfos()) as any;
        if (result.settings.length > 0) {
            this.requiredDeacons = _.find(result.settings, { Name: 'RequiredDeacons' }).IntValue + 1;
            this.requiredExecutive = _.find(result.settings, { Name: 'RequiredExecutiveElders' }).IntValue + 1;
            this.requiredShepherding = _.find(result.settings, { Name: 'RequiredShepherdingElders' }).IntValue + 1;
        }

        this.deacons = [];
        for (let index = 0; index < this.requiredDeacons; index++) {
            const nom = new NominationInfo();
            nom.role = 'Deacon';
            this.deacons.push(nom);
        }

        this.sheps = [];
        for (let index = 0; index < this.requiredShepherding; index++) {
            const nom = new NominationInfo();
            nom.role = 'Shepherding Elder';
            this.sheps.push(nom);
        }

        this.execs = [];
        for (let index = 0; index < this.requiredExecutive; index++) {
            const nom = new NominationInfo();
            nom.role = 'Executive Elder';
            this.execs.push(nom);
        }

        // this.nomination = this.uow.nominations.createEntity();

        await this.getData();
        await this.getTallyData();
        this.people = await this.uow.getPeopleForNominations();
        this.isAdmin = this.auth.hasRole('Nominations:Admin');
    }

    async ngOnDestroy() {
        this.uow.rollback();
    }

    async getData() {
        this.nominationTallyGroups = await this.uow.getNominationTallyGroups();
        // console.log(this.nominationTallyGroups )
    }
    async getTallyData() {
        this.nominationTallies = await this.uow.getNominationTallies();
        // console.log(this.nominationTallies )
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            }
        );
    }

    onSelectionChange(e) {
        if (e.rowType === 'data') {
            if (!!e.data.currentMonth) {
                e.rowElement.className = e.rowElement.className + ' currentMonth-grid ';
            }
            if (!!e.data.nextMonth) {
                e.rowElement.className = e.rowElement.className + ' nextMonth-grid ';
            }
        }
    }

    onRowPrepare(e) {}

    async add() {
        const lastAdded = [];
        const index = await this.utility.getNextNumber('BallotIndex');
        this.addProcessing = true;
        this.deacons.forEach((nom) => {
            if (!!nom.id || nom.id === 0) {
                this.uow.nominationTallies.createEntity({
                    ballotIndex: index,
                    role: 'D',
                    ballotNumber: nom.id,
                    created: new Date(),
                });
                lastAdded.push(`D-${nom.id}`);
            }
        });
        this.execs.forEach((nom) => {
            if (!!nom.id || nom.id === 0) {
                this.uow.nominationTallies.createEntity({
                    ballotIndex: index,
                    role: 'E',
                    ballotNumber: nom.id,
                    created: new Date(),
                });
                lastAdded.push(`E-${nom.id}`);
            }
        });
        this.sheps.forEach((nom) => {
            if (!!nom.id || nom.id === 0) {
                this.uow.nominationTallies.createEntity({
                    ballotIndex: index,
                    role: 'S',
                    ballotNumber: nom.id,
                    created: new Date(),
                });
                lastAdded.push(`S-${nom.id}`);
            }
        });

        await this.uow.commit();
        this.lastAdded = lastAdded;
        this.addProcessing = false;
        await this.getData();
        this.clear();
    }

    clear() {
        this.deacons.forEach((x) => {
            x.id = null;
        });
        this.sheps.forEach((x) => {
            x.id = null;
        });
        this.execs.forEach((x) => {
            x.id = null;
        });
    }

    async refreshTallies() {
        this.appInfo.pleaseWaitShow();
        await this.getTallyData();
        this.appInfo.pleaseWaitHide();
    }

    async deleteNomination() {
        const selectedRow = this.nominationGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;

        selectedRow.entityAspect.setDeleted();
        await this.uow.commit();
        await this.getData();
        await this.getTallyData();
    }

    async closeAll() {
        const result = await confirm(`Are you sure you want to CLOSE all nomination tallies?`, `${this.appInfo.settings.church}`);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        await this.getTallyData();
        this.nominationTallies.forEach((x) => {
            x.closed = new Date();
        });

        await this.uow.commit();
        await this.getData();
        await this.getTallyData();
        this.appInfo.pleaseWaitHide();
    }

    async printNominationBallot() {
        await this.utility.printNominationBallot();
    }
}
class NominationItem {
    id: number;
    personName: string;
    personId: number;
    role: string;
    constructor() {}
}
class NominationInfo {
    id: number;
    role: string;
}
